// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"894c609b","174":"90fca41f","239":"28ee2d0f","281":"b7479899","310":"7abfac85","335":"06b0e727","345":"87f66e9a","432":"0d66c6fe","488":"81549973","675":"a77b8c1f","723":"e79fdaff","778":"a900fbfe","785":"05672948","893":"9db52a6f","977":"ee4885fc"}[chunkId] + ".chunk.js";
};